import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Utility } from '@libs/apis';
import { IGeoTestManagerApiOperation } from '../models/IGeoTestManagerApiOperation';
import {
  IClonableGeoTestsResponse,
  ICloneGeoTestRequest,
  ICloneGeoTestResponse,
  ICreateJiraTicketRequest,
  ICreateJiraTicketResponse
} from '../models/IGeoTestManager';

const promiseFrom = lastValueFrom;

export class GeoTestManagerApis implements IGeoTestManagerApiOperation {
  private constructor(
    private readonly httpClient: HttpClient,
    private readonly apiV1: string,
    private readonly apiV2: string
  ) {}

  public static geoTestManagerApiOperation(
    httpClient: HttpClient,
    apiV1: string,
    apiV2: string
  ): IGeoTestManagerApiOperation {
    return new GeoTestManagerApis(httpClient, apiV1, apiV2);
  }

  public async getClonableTests(
    clientId: number,
    brandId: number
  ): Promise<IClonableGeoTestsResponse> {
    const url = Utility.buildURL({
      url: `${this.apiV1}/bff/geo/tests/clonable`,
      queryParameters: { clientId, brandId }
    });
    return promiseFrom(this.httpClient.get<IClonableGeoTestsResponse>(url));
  }

  public async cloneTest(
    studyId: number,
    request: ICloneGeoTestRequest
  ): Promise<ICloneGeoTestResponse> {
    const url = Utility.buildURL({
      url: `${this.apiV1}/bff/geo/tests/:studyId/clone`,
      pathVariables: { studyId }
    });
    return promiseFrom(
      this.httpClient.post<ICloneGeoTestResponse>(url, request)
    );
  }

  public async createJiraTicket(
    studyId: number,
    request: ICreateJiraTicketRequest
  ): Promise<ICreateJiraTicketResponse> {
    const url = Utility.buildURL({
      url: `${this.apiV1}/bff/geo/tests/:studyId/jira-ticket`,
      pathVariables: { studyId }
    });
    return promiseFrom(
      this.httpClient.post<ICreateJiraTicketResponse>(url, request)
    );
  }
}
